import type { featureConfigs } from '../config';
import type { Feature, FeatureConfigInput } from '../types';

type FeatureConfigs = typeof featureConfigs;

export const getFeatureDirectly = (
  overrides: Feature[],
  featureConfigs: FeatureConfigs,
  input: FeatureConfigInput,
  feature: string,
) =>
  overrides.find((o) => o.name === feature)?.enabled ||
  featureConfigs.find((config) => config.name === feature)?.toFeature(input)
    .enabled;
